import React, { useEffect, useState } from "react";
import {
    Button, Form, Badge, Card, Spinner, Modal,
    Row, Col, Container, InputGroup, Table
} from 'react-bootstrap';
import Menu from '../../comum/Menu/menu.jsx';
import { useNavigate } from "react-router-dom";
import Footer from '../../comum/Footer/index.jsx';
import { api } from '../../services/api.js';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './equipamento.css';

const MySwal = withReactContent(Swal);

function ControleEquipamentos() {
    const [loading, setLoading] = useState(false);
    const [equipamentos, setEquipamentos] = useState([]);
    const [filtroBusca, setFiltroBusca] = useState("");
    const [filtroStatus, setFiltroStatus] = useState("T");
    const [isImagemView, setIsImagemView] = useState(false);

    // Modais Principais
    const [showModalCadastro, setShowModalCadastro] = useState(false);
    const [showModalVinculo, setShowModalVinculo] = useState(false);
    const [showModalAbrirManut, setShowModalAbrirManut] = useState(false);
    const [showModalOrcamento, setShowModalOrcamento] = useState(false);
    const [showModalFinalizarManut, setShowModalFinalizarManut] = useState(false);
    const [showModalLogs, setShowModalLogs] = useState(false);
    const [showModalDetalhes, setShowModalDetalhes] = useState(false);
    const chapa = localStorage.getItem("chapa");
    const permiteCheckList = localStorage.getItem("CHECKLIST");
    const [showModalTermoObs, setShowModalTermoObs] = useState(false);
    const [obsTermo, setObsTermo] = useState("");
    const [eqpParaTermo, setEqpParaTermo] = useState(null);

    // Modal de Visualização de Anexo
    const [showModalAnexo, setShowModalAnexo] = useState(false);
    const [urlAnexoView, setUrlAnexoView] = useState("");
    const [tituloAnexoView, setTituloAnexoView] = useState("");
    const navigate = useNavigate();

    // Modos
    const [modoEdicao, setModoEdicao] = useState(false);

    // Seleção
    const [eqpSelecionado, setEqpSelecionado] = useState(null);
    const [logs, setLogs] = useState([]);

    const formatarMoedaBR = (valor) => {
        if (valor === undefined || valor === null || valor === "") return "R$ 0,00";
        let num = 0;
        if (typeof valor === "number") {
            num = valor;
        } else {
            const limpo = String(valor).replace(/[^\d,.]/g, "").replace(",", ".");
            num = Number(limpo) || 0;
        }
        return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    };

    const aplicarMascaraMoeda = (valorStr) => {
        const apenasDigitos = String(valorStr).replace(/\D/g, "");
        if (!apenasDigitos) return "R$ 0,00";
        const numero = Number(apenasDigitos) / 100;
        return numero.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    };

    const parseMoedaParaNumero = (moedaStr) => {
        if (!moedaStr) return 0;
        const limpo = String(moedaStr).replace(/[^\d,]/g, "").replace(",", ".");
        return Number(limpo) || 0;
    };

    const [formCadastro, setFormCadastro] = useState({
        eqp_tipo: "NOTEBOOK",
        eqp_serie: "",
        eqp_marca: "",
        eqp_modelo: "",
        eqp_descricao: "",
        eqp_cnpjnota: "",
        eqp_numnota: 0,
        eqp_serienota: "",
        eqp_idnfe: "",
        eqp_datacompra: "",
        eqp_valor: "R$ 0,00",
        eqp_observacao: "",
        eqp_celular: ""
    });

    const [tipoVinculo, setTipoVinculo] = useState("U");
    const [chapaUsuario, setChapaUsuario] = useState("");
    const [nomeUsuario, setNomeUsuario] = useState("");
    const [codLoja, setCodLoja] = useState("");
    const [celularUsuario, setCelularUsuario] = useState("");

    const [formAbrirManut, setFormAbrirManut] = useState({
        prestador: "",
        numchamado_prestador: "",
        numchamado_local: "",
        cod_emp_origem: "",
        defeito_relatado: ""
    });

    const [formOrcamento, setFormOrcamento] = useState({
        valor_orcamento: "R$ 0,00",
        defeito_constatado: "",
        arq_orcamento: null,
        acao_aprova: 'Orçamento Enviado'
    });

    const [formFinalizarManut, setFormFinalizarManut] = useState({
        valor_final: "R$ 0,00",
        servico_realizado: "",
        arq_notafiscal: null
    });

    const usuarioLogado = localStorage.getItem("usuario_matricula") || localStorage.getItem("chapa") || "";

    const decodeBase64Safe = (str) => {
        if (!str) return "";
        try {
            return decodeURIComponent(
                atob(str)
                    .split('')
                    .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
        } catch (e) {
            try {
                return atob(str);
            } catch (err) {
                return str;
            }
        }
    };

    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
            return;
        } else if (permiteCheckList !== "S") {
            Swal.fire({ icon: 'error', title: 'Acesso Negado', text: 'Não é permitido acessar o CheckList.', confirmButtonText: 'OK' })
                .then(() => navigate("/arbor/home"));
        }
        carregarEquipamentos();
    }, [filtroStatus]);

    const carregarEquipamentos = async () => {
        setLoading(true);
        try {
            const res = await api.get(`/equipamentos?busca=${encodeURIComponent(filtroBusca)}&status=${filtroStatus}`);
            let dados = Array.isArray(res.data) ? res.data : [];

            if (filtroBusca.trim() !== "") {
                const termo = filtroBusca.toLowerCase();
                dados = dados.filter(e => {
                    const serie = String(e.EQP_SERIE || e.eqp_serie || "").toLowerCase();
                    const marca = String(e.EQP_MARCA || e.eqp_marca || "").toLowerCase();
                    const modelo = String(e.EQP_MODELO || e.eqp_modelo || "").toLowerCase();
                    const usuario = String(e.NOME_USUARIO || e.nome_usuario || "").toLowerCase();
                    const loja = String(e.NOME_LOJA || e.nome_loja || "").toLowerCase();
                    const celular = String(e.EQP_CELULAR || e.eqp_celular || "").toLowerCase();

                    return serie.includes(termo) ||
                        marca.includes(termo) ||
                        modelo.includes(termo) ||
                        usuario.includes(termo) ||
                        loja.includes(termo) ||
                        celular.includes(termo);
                });
            }

            setEquipamentos(dados);
        } catch (err) {
            toast.error("Erro ao carregar equipamentos.");
        } finally {
            setLoading(false);
        }
    };

    const handleEnviarNfPendente = async (eqpmId, file) => {
        setLoading(true);
        try {
            const base64Nota = await convertFileToBase64(file);
            await api.post('/equipamento/manutencao/anexar-nf', {
                eqpm_id: eqpmId,
                base64_notafiscal: base64Nota,
                nome_notafiscal: file.name,
                usuario_logado: usuarioLogado
            });
            toast.success("Nota fiscal anexada com sucesso!");

            const serieEqp = eqpSelecionado?.EQP_SERIE || eqpSelecionado?.eqp_serie;
            const res = await api.get(`/equipamento/logs/${encodeURIComponent(serieEqp)}`);
            setLogs(Array.isArray(res.data) ? res.data : []);
            carregarEquipamentos();
        } catch (err) {
            toast.error("Erro ao enviar a nota fiscal.");
        } finally {
            setLoading(false);
        }
    };

    const handleInativarEquipamento = async (eqp) => {
        const serie = eqp.EQP_SERIE || eqp.eqp_serie;
        const confirm = await MySwal.fire({
            title: 'Inativar Equipamento?',
            text: `Deseja realmente INATIVAR o equipamento de série ${serie}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, Inativar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#d33'
        });

        if (confirm.isConfirmed) {
            setLoading(true);
            try {
                await api.put(`/equipamento/inativar/${encodeURIComponent(serie)}`, {
                    usuario_logado: usuarioLogado
                });
                toast.success("Equipamento inativado com sucesso!");
                carregarEquipamentos();
            } catch (err) {
                toast.error("Erro ao inativar o equipamento.");
            } finally {
                setLoading(false);
            }
        }
    };

    const handleBuscarUsuario = async () => {
        if (!chapaUsuario) return;
        try {
            const res = await api.get(`/usuario/foto/${chapaUsuario}`);
            if (res.data && res.data.nome) {
                setNomeUsuario(res.data.nome);
            } else {
                toast.warning("Usuário não encontrado.");
                setNomeUsuario("");
            }
        } catch (err) {
            toast.error("Erro ao buscar dados do colaborador.");
            setNomeUsuario("");
        }
    };

    // Componente com Cache para Foto do EPI
    
    const handleSalvarEquipamento = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        try {
            const payload = {
                ...formCadastro,
                eqp_valor: parseMoedaParaNumero(formCadastro.eqp_valor),
                eqp_numnota: Number(formCadastro.eqp_numnota) || 0,
                usuario_logado: usuarioLogado
            };

            await api.post('/equipamento', payload);
            toast.success(modoEdicao ? "Equipamento atualizado com sucesso!" : "Equipamento cadastrado com sucesso!");
            setShowModalCadastro(false);
            setShowModalDetalhes(false);
            carregarEquipamentos();
        } catch (err) {
            toast.error("Erro ao salvar equipamento.");
        } finally {
            setLoading(false);
        }
    };

    const handleVincularEquipamento = async (e) => {
        e.preventDefault();

        if (tipoVinculo === 'U' && !nomeUsuario) {
            toast.warning("Valide a chapa do colaborador antes de vincular.");
            return;
        }

        if (tipoVinculo === 'L' && !codLoja) {
            toast.warning("Informe o código da loja.");
            return;
        }

        setLoading(true);
        try {
            const serie = eqpSelecionado?.EQP_SERIE || eqpSelecionado?.eqp_serie;
            await api.post('/equipamento/vincular', {
                eqp_serie: serie,
                tipo_destino: tipoVinculo,
                eqp_usuario: tipoVinculo === 'U' ? chapaUsuario : null,
                eqp_cod_emp: tipoVinculo === 'L' ? Number(codLoja) : null,
                eqp_celular: celularUsuario,
                eqp_status: 'A',
                usuario_logado: usuarioLogado
            });
            toast.success("Equipamento vinculado com sucesso!");
            setShowModalVinculo(false);
            carregarEquipamentos();
        } catch (err) {
            toast.error("Erro ao vincular equipamento.");
        } finally {
            setLoading(false);
        }
    };

    const handleDesvincular = async (eqp) => {
        const serie = eqp?.EQP_SERIE || eqp?.eqp_serie;
        const confirm = await MySwal.fire({
            title: 'Desvincular Equipamento?',
            text: `Deseja remover o vínculo da série ${serie}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, Desvincular',
            cancelButtonText: 'Cancelar'
        });

        if (confirm.isConfirmed) {
            setLoading(true);
            try {
                await api.post('/equipamento/desvincular', {
                    eqp_serie: serie,
                    usuario_logado: usuarioLogado,
                    eqp_status: 'D'
                });
                toast.success("Equipamento desvinculado!");
                carregarEquipamentos();
            } catch (err) {
                toast.error("Erro ao desvincular.");
            } finally {
                setLoading(false);
            }
        }
    };

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                resolve("");
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const res = reader.result;
                if (typeof res === 'string') {
                    const parts = res.split(',');
                    resolve(parts.length > 1 ? parts[1] : res);
                } else {
                    resolve("");
                }
            };
            reader.onerror = (error) => reject(error);
        });
    };

    const handleAbrirManutencao = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const serie = eqpSelecionado?.EQP_SERIE || eqpSelecionado?.eqp_serie;
            const payload = {
                eqp_serie: serie,
                prestador: formAbrirManut.prestador,
                numchamado_prestador: formAbrirManut.numchamado_prestador || "",
                numchamado_local: formAbrirManut.numchamado_local || "",
                cod_emp_origem: Number(formAbrirManut.cod_emp_origem) || 0,
                defeito_relatado: formAbrirManut.defeito_relatado,
                usuario_logado: usuarioLogado
            };

            await api.post('/equipamento/manutencao/abrir', payload);
            toast.success("Envio para manutenção registrado com sucesso!");
            setShowModalAbrirManut(false);
            carregarEquipamentos();
        } catch (err) {
            toast.error("Erro ao abrir manutenção.");
        } finally {
            setLoading(false);
        }
    };

    const handleSalvarOrcamento = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const serie = eqpSelecionado?.EQP_SERIE || eqpSelecionado?.eqp_serie;
            let base64Orc = "";
            let nomeOrc = "";

            if (formOrcamento.arq_orcamento) {
                base64Orc = await convertFileToBase64(formOrcamento.arq_orcamento);
                nomeOrc = formOrcamento.arq_orcamento.name;
            }

            const payload = {
                eqp_serie: serie,
                valor_orcamento: parseMoedaParaNumero(formOrcamento.valor_orcamento),
                defeito_constatado: formOrcamento.defeito_constatado || "",
                status_orcamento: formOrcamento.acao_aprova || "Orçamento Enviado",
                usuario_logado: usuarioLogado,
                base64_orcamento: base64Orc,
                nome_orcamento: nomeOrc
            };

            await api.post('/equipamento/manutencao/orcamento', payload);
            toast.success(`Orçamento gravado como: ${formOrcamento.acao_aprova}!`);
            setShowModalOrcamento(false);
            carregarEquipamentos();
        } catch (err) {
            toast.error("Erro ao salvar orçamento.");
        } finally {
            setLoading(false);
        }
    };

    const handleImprimirTermo = (eqp) => {
        setEqpParaTermo(eqp);
        setObsTermo("");
        setShowModalTermoObs(true);
    };

    const executarImpressaoTermo = async () => {
        if (!eqpParaTermo) return;
        setShowModalTermoObs(false);
        const serie = eqpParaTermo.EQP_SERIE || eqpParaTermo.eqp_serie;
        setLoading(true);
        try {
            const res = await api.get(`/equipamento/termo/${encodeURIComponent(serie)}`);
            const dados = res.data;

            const janelaImpressao = window.open('', '_blank', 'width=900,height=1100');
            if (!janelaImpressao) {
                toast.warning("Permita pop-ups no navegador para gerar o termo.");
                return;
            }

            const formatarCPF = (cpf) => {
                const limpo = String(cpf || "").replace(/\D/g, "");
                if (limpo.length !== 11) return cpf || "---";
                return `${limpo.slice(0, 3)}.${limpo.slice(3, 6)}.${limpo.slice(6, 9)}-${limpo.slice(9)}`;
            };

            const formatarCelular = (cel) => {
                const limpo = String(cel || "").replace(/\D/g, "");
                if (limpo.length === 11) {
                    return `(${limpo.slice(0, 2)}) ${limpo.slice(2, 7)}-${limpo.slice(7)}`;
                } else if (limpo.length === 10) {
                    return `(${limpo.slice(0, 2)}) ${limpo.slice(2, 6)}-${limpo.slice(6)}`;
                }
                return cel || "";
            };

            const nomeColabBD = dados.NOME || dados.nome || dados.EQP_USUARIO || dados.eqp_usuario;
            const cpfColabBD = formatarCPF(dados.CPF || dados.cpf);
            const nomeLojaBD = dados.NOME_LOJA || dados.nome_loja;
            const codEmpBD = dados.EQP_COD_EMP || dados.eqp_cod_emp;

            // Se for vinculado a loja, o "nomeColaborador" principal do termo passa a ser o nome da Loja/Empresa
            let titularTermo = "";
            let blocoAssinatura = "";
            let textoDeclaracao = "";

            if (nomeLojaBD || (codEmpBD && !nomeColabBD)) {
                titularTermo = `Loja ${codEmpBD || ''} - ${nomeLojaBD || 'Floresta Comércio e Indústria S/A'}`;
                textoDeclaracao = `A empresa <b>${titularTermo}</b>, por intermédio de seu colaborador abaixo identificado, DECLARA estar recebendo, nesta data, o(s) seguinte(s) bem(ns) de propriedade da empresa:`;
                blocoAssinatura = `
                    <div class="signatures">
                        <div class="sig-block">
                            <div class="sig-line"></div>
                            Floresta Comércio e Indústria S.A.
                        </div>
                        <div class="sig-block">
                            <div class="sig-line"></div>
                            Nome: ___________________________________<br>
                            CPF: __________________ - Assinatura: ______
                        </div>
                    </div>
                `;
            } else {
                titularTermo = nomeColabBD || "Colaborador";
                textoDeclaracao = `Eu, <strong><u>${titularTermo}</u></strong>, inscrito(s) no CPF nº <strong><u>${cpfColabBD}</u></strong>, colaborador(a) da <b>Empresa Floresta Comércio e Indústria S/A</b>, DECLARO, por este instrumento, estar recebendo, nesta data, o(s) seguinte(s) bem(ns) de propriedade da empresa:`;
                blocoAssinatura = `
                    <div class="signatures">
                        <div class="sig-block">
                            <div class="sig-line"></div>
                            Floresta Comércio e Indústria S.A.
                        </div>
                        <div class="sig-block">
                            <div class="sig-line"></div>
                            ${titularTermo}
                        </div>
                    </div>
                `;
            }

            const cidadeEmpresa = dados.CIDADE || dados.cidade || "Volta Redonda";
            const dataAtual = new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });

            const htmlTermo = `
            <!DOCTYPE html>
            <html lang="pt-BR">
            <head>
                <meta charset="UTF-8">
                <title>Termo de Responsabilidade - ${serie}</title>
                <style>
                    @page { size: A4; margin: 8mm; }
                    body { font-family: Arial, sans-serif; font-size: 9pt; color: #000; margin: 0; padding: 0; background: #fff; }
                    .container { width: 100%; max-width: 800px; margin: 0 auto; }
                    .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #000; padding-bottom: 4px; margin-bottom: 5px; }
                    .header img.logo-floresta { height: 38px; object-fit: contain; }
                    .company-info { text-align: right; font-size: 8pt; line-height: 1.2; }
                    .title { text-align: center; font-size: 10pt; font-weight: bold; margin: 5px 0; background: #eee; padding: 4px; border: 1px solid #ccc; letter-spacing: 0.5px; }
                    .content p { text-align: justify; line-height: 1.3; margin-bottom: 5px; }
                    .equipment-box { border: 1px solid #000; padding: 5px 10px; margin: 5px 0; background: #fdfdfd; line-height: 1.4; font-size: 9pt; }
                    .obs-box { border: 1px dashed #666; padding: 6px; margin: 5px 0; background: #fffdf0; font-size: 8.5pt; }
                    .rules b u { font-size: 9pt; }
                    .rules h4 { font-size: 9pt; margin: 3px 0 1px 0; }
                    .rules ul { margin: 0 0 3px 0; padding-left: 15px; font-size: 8.5pt; line-height: 1.25; }
                    .rules li { margin-bottom: 1px; }
                    .footer-date { text-align: center; margin: 8px 0 12px 0; font-size: 9pt; }
                    .signatures { display: flex; justify-content: space-between; margin-top: 12px; text-align: center; font-size: 9pt; }
                    .sig-block { width: 45%; }
                    .sig-line { width: 100%; border-top: 1px solid #000; margin: 0 auto 3px auto; }
                    .footer-arbor { text-align: right; margin-top: 8px; border-top: 1px solid #ccc; padding-top: 4px; }
                    .footer-arbor img { height: 132px; object-fit: contain; }
                    @media print { body { padding: 0; } }
                </style>
            </head>
            <body>
                <div class="container">
                    <div class="header">
                        <div><img src="/Images/Floresta.png" alt="Floresta" class="logo-floresta" /></div>
                        <div class="company-info">
                            <strong>Floresta Comércio e Indústria S.A.</strong><br>
                            CNPJ: 32.500.977/0001-64<br>
                            Loja 01 (Sede) - Avenida Paulo Erlei Alves Abrantes, 10.000 - Três Poços - Volta Redonda - RJ - CEP: 27.240-560<br>
                            Telefone: (24) 3340-2042
                        </div>
                    </div>

                    <div class="title">TERMO DE RESPONSABILIDADE E USO DE EQUIPAMENTO</div>

                    <div class="content">
                        <p>${textoDeclaracao}</p>

                        <div class="equipment-box">
                            Tipo: <strong><u>${dados.EQP_TIPO || dados.eqp_tipo || ''}</u></strong><br>
                            Equipamento: <strong><u>${dados.EQP_MODELO || dados.eqp_modelo || ''}</u></strong><br>
                            Marca/Modelo: <strong><u>${dados.EQP_MARCA || dados.eqp_marca || ''}</u></strong><br>
                            Número de Série/Patrimônio: <strong><u>${dados.EQP_SERIE || dados.eqp_serie || ''}</u></strong><br>
                            Valor de Aquisição (R$): <strong><u>${formatarMoedaBR(dados.EQP_VALOR || dados.eqp_valor)}</u></strong>
                            ${((dados.EQP_TIPO || dados.eqp_tipo) === 'CELULAR' && (dados.EQP_CELULAR || dados.eqp_celular)) ? `<br>Telefone: <strong><u>${formatarCelular(dados.EQP_CELULAR || dados.eqp_celular)}</u></strong>` : ''}
                        </div>

                        ${obsTermo ? `<div class="obs-box"><strong>Observações / Condições Especiais:</strong> ${obsTermo}</div>` : ''}

                        <div class="rules">
                            <b><u>1. RESPONSABILIDADE DO USUÁRIO</u></b>
                            <ul>
                                <li>Comprometo-me a zelar pela conservação, guarda e uso adequado do(s) equipamento(s), conforme orientações do fabricante e normas internas da empresa.</li>
                                <li>É de minha responsabilidade:
                                    <ul style="list-style-type: disc; margin-top: 1px;">
                                        <li>Utilizar o equipamento exclusivamente para fins corporativos/profissionais;</li>
                                        <li>Mantê-lo em local seguro, livre de riscos de perda, roubo ou dano;</li>
                                        <li>Utilizar somente carregadores, adaptadores e acessórios originais;</li>
                                        <li>Não emprestar, transferir ou permitir uso por terceiros sem autorização formal;</li>
                                        <li>Comunicar imediatamente ao setor de TI e/ou RH qualquer dano, falha, extravio ou roubo.</li>
                                    </ul>
                                </li>
                            </ul>

                            <b><u>2. RESPONSABILIDADE FINANCEIRA</u></b>
                            <ul>
                                <li>Reconheço que sou responsável pelo custo de reparo ou substituição em caso de dano decorrente de mau uso, negligência, uso inadequado ou perda do equipamento.</li>
                                <li>Em caso de roubo/furto, deverá ser apresentada cópia do Boletim de Ocorrência (B.O.) no prazo máximo de 48 horas.</li>
                                <li>Autorizo o desconto em folha de pagamento ou cobrança administrativa do valor correspondente, quando comprovada minha responsabilidade.</li>
                                <li>Declaro ciência de que o valor do equipamento informado neste termo poderá ser utilizado como base para cobrança em caso de perda, dano irreparável ou não devolução.</li>
                            </ul>

                            <b><u>3. DEVOLUÇÃO EM CASO DE RESCISÃO</u></b>
                            <ul>
                                <li>Em caso de rescisão do contrato de trabalho, por qualquer motivo, comprometo-me a devolver o equipamento nas mesmas condições em que o recebi, salvo o desgaste natural pelo uso.</li>
                                <li>Caso não haja devolução ou o bem seja entregue com danos que comprometam sua utilização, autorizo desde já o desconto integral ou proporcional do valor de aquisição declarado neste termo, a critério da empresa.</li>
                            </ul>

                            <b><u>4. POLÍTICA DE PRIVACIDADE E PROTEÇÃO DE DADOS</u></b>
                            <ul>
                                <li>Os dados pessoais aqui coletados têm por finalidade a identificação do colaborador responsável pelo equipamento corporativo.</li>
                                <li>Os dados serão armazenados pelo prazo de 5 (cinco) anos a partir da devolução do equipamento ou encerramento do contrato de trabalho, sendo posteriormente descartados de forma segura.</li>
                                <li>Os dados poderão ser compartilhados com os setores de RH, Financeiro e TI para controle patrimonial e eventual aplicação de vale/substituição.</li>
                                <li>Em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018), qualquer solicitação relativa ao tratamento das informações poderá ser feita junto ao Encarregado de Dados (DPO), através do e-mail: <b><u>dpo@florestasm.com.br</u></b></li>
                            </ul>

                            <b><u>5. DISPOSIÇÕES GERAIS</u></b>
                            <ul>
                                <li>O presente termo é firmado em duas vias de igual teor, passando a produzir efeitos legais a partir da assinatura.</li>
                                <li>Ocorrendo substituição temporária ou definitiva do colaborador ou do equipamento, por determinação da diretoria, deverá ser emitido novo Termo de Responsabilidade.</li>
                                <li>Declaro estar ciente e de acordo com todas as condições aqui estabelecidas.</li>
                            </ul>
                        </div>
                        <br>

                        <div class="footer-date">${cidadeEmpresa}, ${dataAtual}</div>
                        <br><br><br>

                        ${blocoAssinatura}

                        <div class="footer-arbor">
                            <img src="/Images/arbor.png" alt="Arbor" />
                        </div>
                    </div>
                </div>
                <script>
                    window.onafterprint = function() {
                        window.close();
                    };
                    window.onload = function() {
                        window.print();
                        // Fallback caso o evento afterprint não dispare em algum navegador específico
                        setTimeout(function() {
                            window.close();
                        }, 500);
                    };
                </script>
            </body>
            </html>`;

            janelaImpressao.document.write(htmlTermo);
            janelaImpressao.document.close();
        } catch (err) {
            toast.error("Erro ao gerar o termo de responsabilidade.");
        } finally {
            setLoading(false);
        }
    };

    const handleFinalizarManutencao = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const serie = eqpSelecionado?.EQP_SERIE || eqpSelecionado?.eqp_serie;
            let base64Nota = "";
            let nomeNota = "";

            if (formFinalizarManut.arq_notafiscal) {
                base64Nota = await convertFileToBase64(formFinalizarManut.arq_notafiscal);
                nomeNota = formFinalizarManut.arq_notafiscal.name;
            }

            const payload = {
                eqp_serie: serie,
                valor_final: parseMoedaParaNumero(formFinalizarManut.valor_final),
                servico_realizado: formFinalizarManut.servico_realizado || "",
                usuario_logado: usuarioLogado,
                base64_notafiscal: base64Nota,
                nome_notafiscal: nomeNota
            };

            await api.post('/equipamento/manutencao/finalizar', payload);
            toast.success("Manutenção Finalizada com Sucesso!");
            setShowModalFinalizarManut(false);
            carregarEquipamentos();
        } catch (err) {
            toast.error("Erro ao finalizar manutenção.");
        } finally {
            setLoading(false);
        }
    };

    const handleVerLogs = async (eqp) => {
        const serie = eqp?.EQP_SERIE || eqp?.eqp_serie;
        if (!serie) {
            toast.error("Série do equipamento inválida.");
            return;
        }

        setEqpSelecionado(eqp);
        setLoading(true);
        try {
            const res = await api.get(`/equipamento/logs/${encodeURIComponent(serie)}`);
            setLogs(Array.isArray(res.data) ? res.data : []);
            setShowModalLogs(true);
        } catch (err) {
            toast.error("Erro ao carregar logs do equipamento.");
        } finally {
            setLoading(false);
        }
    };

    const handleVisualizarAnexoEmTela = async (eqpmId, tipo, titulo) => {
        setLoading(true);
        try {
            if (urlAnexoView) {
                URL.revokeObjectURL(urlAnexoView);
            }

            const response = await api.get(`/equipamento/manutencao/download/${eqpmId}/${tipo}`, {
                responseType: 'blob'
            });

            const contentType = response.headers['content-type'] || '';
            const isImg = contentType.includes('image');

            const fileBlob = new Blob([response.data], { type: contentType || 'application/pdf' });
            const blobUrl = URL.createObjectURL(fileBlob);

            setIsImagemView(isImg);
            setUrlAnexoView(blobUrl);
            setTituloAnexoView(titulo);
            setShowModalAnexo(true);
        } catch (err) {
            toast.error("Não foi possível carregar o anexo para visualização.");
        } finally {
            setLoading(false);
        }
    };

    const handleFecharModalAnexo = () => {
        if (urlAnexoView) {
            URL.revokeObjectURL(urlAnexoView);
            setUrlAnexoView("");
        }
        setShowModalAnexo(false);
    };

    const formatarDataParaInput = (dataStr) => {
        if (!dataStr) return "";
        if (dataStr.includes("/")) {
            const [dia, mes, ano] = dataStr.split("/");
            return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        }
        if (dataStr.includes("-")) {
            return dataStr.split("T")[0];
        }
        return "";
    };

    const handleAbrirDetalhes = (eqp) => {
        setEqpSelecionado(eqp);
        setModoEdicao(false);

        const descBruta = eqp.EQP_DESCRICAO || eqp.eqp_descricao || "";
        const descDecodificada = decodeBase64Safe(descBruta);

        const valorBruto = eqp.EQP_VALOR ?? eqp.eqp_valor ?? 0;
        const celularAtual = eqp.EQP_CELULAR || eqp.eqp_celular || "";

        setFormCadastro({
            eqp_tipo: eqp.EQP_TIPO || eqp.eqp_tipo || "NOTEBOOK",
            eqp_serie: eqp.EQP_SERIE || eqp.eqp_serie || "",
            eqp_marca: eqp.EQP_MARCA || eqp.eqp_marca || "",
            eqp_modelo: eqp.EQP_MODELO || eqp.eqp_modelo || "",
            eqp_descricao: descDecodificada,
            eqp_cnpjnota: eqp.EQP_CNPJNOTA || eqp.eqp_cnpjnota || "",
            eqp_numnota: eqp.EQP_NUMNOTA || eqp.eqp_numnota || 0,
            eqp_serienota: eqp.EQP_SERIENOTA || eqp.eqp_serienota || "",
            eqp_idnfe: eqp.EQP_IDNFE || eqp.eqp_idnfe || "",
            eqp_datacompra: formatarDataParaInput(eqp.EQP_DATACOMPRA || eqp.eqp_datacompra || ""),
            eqp_valor: formatarMoedaBR(valorBruto),
            eqp_observacao: eqp.EQP_OBSERVACAO || eqp.eqp_observacao || "",
            eqp_celular: celularAtual
        });
        setShowModalDetalhes(true);
    };

    const getBadgeStatus = (st) => {
        switch (st) {
            case 'C': return <Badge bg="info">Cadastrado</Badge>;
            case 'A': return <Badge bg="success">Alocado</Badge>;
            case 'E': return <Badge bg="primary">Emprestado</Badge>;
            case 'M': return <Badge bg="warning" text="dark">Em Manutenção</Badge>;
            case 'D': return <Badge bg="secondary">Devolvido</Badge>;
            case 'I': return <Badge bg="danger">Inativo</Badge>;
            default: return <Badge bg="light" text="dark">{st}</Badge>;
        }
    };

    const getDestinoFormatado = (e) => {
        const nomeUsr = e.NOME_USUARIO || e.nome_usuario;
        const nomeLoja = e.NOME_LOJA || e.nome_loja;
        const codEmp = e.EQP_COD_EMP || e.eqp_cod_emp;

        if (nomeUsr) return nomeUsr;
        if (nomeLoja) return `Loja ${codEmp} - ${nomeLoja}`;
        if (codEmp) return `Loja ${codEmp}`;
        return "Sem Vínculo";
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <Menu modulo="ARBOR" />

            <Container fluid className="px-4 mt-4 pt-4 mb-5" style={{ flex: 1 }}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="fw-bold mb-0 text-dark">
                        <i className="fa-solid fa-desktop me-2 text-danger"></i>Controle de Equipamentos TI
                    </h4>
                    <Button
                        variant="danger"
                        className="btn-arbor-primary shadow-sm"
                        onClick={() => {
                            setFormCadastro({
                                eqp_tipo: "NOTEBOOK", eqp_serie: "", eqp_marca: "", eqp_modelo: "",
                                eqp_descricao: "", eqp_cnpjnota: "", eqp_numnota: 0, eqp_serienota: "",
                                eqp_idnfe: "", eqp_datacompra: "", eqp_valor: "R$ 0,00", eqp_observacao: "", eqp_celular: ""
                            });
                            setModoEdicao(false);
                            setShowModalCadastro(true);
                        }}
                    >
                        <i className="fa-solid fa-plus me-1"></i> Novo Equipamento
                    </Button>
                </div>

                {/* Filtros */}
                <Card className="shadow-sm border-0 mb-3 p-3 bg-white rounded-3">
                    <Row className="g-2">
                        <Col md={8}>
                            <InputGroup>
                                <InputGroup.Text className="bg-white border-end-0">
                                    <i className="fa-solid fa-magnifying-glass text-muted"></i>
                                </InputGroup.Text>
                                <Form.Control
                                    className="border-start-0"
                                    placeholder="Buscar por Série, Usuário, Marca, Modelo..."
                                    value={filtroBusca}
                                    onChange={(e) => setFiltroBusca(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && carregarEquipamentos()}
                                />
                                <Button variant="outline-danger" onClick={carregarEquipamentos}>Buscar</Button>
                            </InputGroup>
                        </Col>
                        <Col md={4}>
                            <Form.Select
                                value={filtroStatus}
                                onChange={(e) => setFiltroStatus(e.target.value)}
                            >
                                <option value="T">Todos os Status</option>
                                <option value="C">Cadastrado</option>
                                <option value="A">Alocado</option>
                                <option value="E">Emprestado</option>
                                <option value="M">Manutenção</option>
                                <option value="NP">NF Pendente</option>
                                <option value="D">Devolvido</option>
                                <option value="I">Inativo</option>
                            </Form.Select>
                        </Col>
                    </Row>
                </Card>

                {/* Tabela de Equipamentos */}
                <Card className="shadow-sm border-0 bg-white rounded-3 overflow-hidden">
                    <Card.Body className="p-0">
                        <Table responsive hover className="align-middle mb-0">
                            <thead className="table-dark">
                                <tr>
                                    <th>Tipo</th>
                                    <th>Série</th>
                                    <th>Marca / Modelo</th>
                                    <th>Usuário / Loja</th>
                                    <th>Status</th>
                                    <th className="text-end px-3">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {equipamentos.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className="text-center py-4 text-muted">
                                            Nenhum equipamento encontrado.
                                        </td>
                                    </tr>
                                ) : (
                                    equipamentos.map((e, index) => {
                                        const serie = e.EQP_SERIE || e.eqp_serie;
                                        const st = e.EQP_STATUS || e.eqp_status;
                                        const destinoText = getDestinoFormatado(e);

                                        return (
                                            <tr key={`${serie}-${index}`}>
                                                <td><strong className="text-uppercase">{e.EQP_TIPO || e.eqp_tipo}</strong></td>
                                                <td className="fw-bold text-danger">{serie}</td>
                                                <td>{e.EQP_MARCA || e.eqp_marca} {e.EQP_MODELO || e.eqp_modelo}</td>
                                                <td>{destinoText}</td>
                                                <td>{getBadgeStatus(st)}</td>
                                                <td className="text-end px-3">
                                                    <div className="d-flex justify-content-end gap-1">
                                                        <Button
                                                            size="sm"
                                                            variant="outline-secondary"
                                                            title="Visualizar/Editar Detalhes"
                                                            onClick={() => handleAbrirDetalhes(e)}
                                                        >
                                                            <i className="fa-solid fa-eye me-1"></i> Detalhes
                                                        </Button>

                                                        {(st === 'C' || st === 'D') && (
                                                            <Button
                                                                size="sm"
                                                                variant="outline-success"
                                                                onClick={() => {
                                                                    setEqpSelecionado(e);
                                                                    setTipoVinculo("U");
                                                                    setChapaUsuario("");
                                                                    setNomeUsuario("");
                                                                    setCodLoja("");
                                                                    setCelularUsuario("");
                                                                    setShowModalVinculo(true);
                                                                }}
                                                            >
                                                                Vincular
                                                            </Button>
                                                        )}

                                                        {(st === 'A' || st === 'E') && (
                                                            <Button
                                                                size="sm"
                                                                variant="outline-danger"
                                                                onClick={() => handleDesvincular(e)}
                                                            >
                                                                Desvincular
                                                            </Button>
                                                        )}

                                                        {st !== 'M' ? (
                                                            <Button
                                                                size="sm"
                                                                variant="outline-warning"
                                                                title="Enviar para Manutenção"
                                                                onClick={() => {
                                                                    setEqpSelecionado(e);
                                                                    setFormAbrirManut({
                                                                        prestador: "",
                                                                        numchamado_prestador: "",
                                                                        numchamado_local: "",
                                                                        cod_emp_origem: e.EQP_COD_EMP || e.eqp_cod_emp || 0,
                                                                        defeito_relatado: ""
                                                                    });
                                                                    setShowModalAbrirManut(true);
                                                                }}
                                                            >
                                                                <i className="fa-solid fa-wrench me-1"></i> P/ Manutenção
                                                            </Button>
                                                        ) : (
                                                            <>
                                                                <Button
                                                                    size="sm"
                                                                    variant="info"
                                                                    className="text-white fw-bold"
                                                                    title="Lançar/Aprovar Orçamento"
                                                                    onClick={() => {
                                                                        setEqpSelecionado(e);
                                                                        setFormOrcamento({
                                                                            valor_orcamento: "R$ 0,00",
                                                                            defeito_constatado: "",
                                                                            arq_orcamento: null,
                                                                            acao_aprova: 'Orçamento Enviado'
                                                                        });
                                                                        setShowModalOrcamento(true);
                                                                    }}
                                                                >
                                                                    📄 Orçamento
                                                                </Button>

                                                                <Button
                                                                    size="sm"
                                                                    variant="success"
                                                                    className="fw-bold"
                                                                    title="Finalizar Manutenção com Nota Fiscal"
                                                                    onClick={() => {
                                                                        setEqpSelecionado(e);
                                                                        setFormFinalizarManut({
                                                                            valor_final: "R$ 0,00",
                                                                            servico_realizado: "",
                                                                            arq_notafiscal: null
                                                                        });
                                                                        setShowModalFinalizarManut(true);
                                                                    }}
                                                                >
                                                                    ✔ Finalizar
                                                                </Button>
                                                            </>
                                                        )}
                                                        {st === 'A' && (
                                                            <Button
                                                                size="sm"
                                                                variant="outline-secondary"
                                                                title="Imprimir Termo de Responsabilidade"
                                                                onClick={() => handleImprimirTermo(e)}
                                                            >
                                                                <i className="fa-solid fa-print me-1"></i> Termo
                                                            </Button>
                                                        )}

                                                        {st !== 'I' && (
                                                            <Button
                                                                size="sm"
                                                                variant="outline-danger"
                                                                title="Inativar Equipamento"
                                                                onClick={() => handleInativarEquipamento(e)}
                                                            >
                                                                <i className="fa-solid fa-ban"></i>
                                                            </Button>
                                                        )}

                                                        <Button
                                                            size="sm"
                                                            variant="outline-info"
                                                            title="Ver Histórico / Logs"
                                                            onClick={() => handleVerLogs(e)}
                                                        >
                                                            <i className="fa-solid fa-clock-rotate-left"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Container>

            {/* Modal para Observação do Termo */}
            <Modal show={showModalTermoObs} onHide={() => setShowModalTermoObs(false)} centered>
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title className="h6 fw-bold">🖨️ Imprimir Termo de Responsabilidade</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold">Observações / Informações Adicionais (Opcional)</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Digite alguma informação adicional que deverá constar no termo..."
                            value={obsTermo}
                            onChange={(e) => setObsTermo(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalTermoObs(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={executarImpressaoTermo} className="fw-bold">
                        GERAR E IMPRIMIR TERMO
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Cadastro */}
            <Modal show={showModalCadastro} onHide={() => setShowModalCadastro(false)} size="lg" centered>
                <Form onSubmit={handleSalvarEquipamento}>
                    <Modal.Header closeButton className="modal-header-arbor">
                        <Modal.Title className="h6 fw-bold text-white">Novo Equipamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="g-2 mb-2">
                            <Col md={4}>
                                <Form.Label className="small fw-bold">Tipo</Form.Label>
                                <Form.Select
                                    value={formCadastro.eqp_tipo}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_tipo: e.target.value })}
                                >
                                    <option value="BALANÇA ATENDIMENTO">BALANÇA ATENDIMENTO</option>
                                    <option value="BALANÇA PDV">BALANÇA PDV</option>
                                    <option value="CELULAR">CELULAR</option>
                                    <option value="COLETOR">COLETOR</option>
                                    <option value="DESKTOP">DESKTOP</option>
                                    <option value="IMPRESSORA">IMPRESSORA</option>
                                    <option value="LEITOR">LEITOR</option>
                                    <option value="MONITOR">MONITOR</option>
                                    <option value="NOTEBOOK">NOTEBOOK</option>
                                    <option value="PINPAD">PINPAD</option>
                                    <option value="SCANER PDV">SCANER PDV</option>
                                    <option value="TELEVISÃO">TELEVISÃO</option>
                                </Form.Select>
                            </Col>
                            <Col md={8}>
                                <Form.Label className="small fw-bold">Número de Série</Form.Label>
                                <Form.Control
                                    required
                                    value={formCadastro.eqp_serie}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_serie: e.target.value })}
                                />
                            </Col>
                        </Row>
                        <Row className="g-2 mb-2">
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Marca</Form.Label>
                                <Form.Control
                                    required
                                    value={formCadastro.eqp_marca}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_marca: e.target.value })}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Modelo</Form.Label>
                                <Form.Control
                                    required
                                    value={formCadastro.eqp_modelo}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_modelo: e.target.value })}
                                />
                            </Col>
                        </Row>
                        <Form.Group className="mb-2">
                            <Form.Label className="small fw-bold">Configuração / Descrição</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                value={formCadastro.eqp_descricao}
                                onChange={(e) => setFormCadastro({ ...formCadastro, eqp_descricao: e.target.value })}
                            />
                        </Form.Group>
                        <Row className="g-2 mb-2">
                            <Col md={4}>
                                <Form.Label className="small fw-bold">Valor (R$)</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formCadastro.eqp_valor}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_valor: aplicarMascaraMoeda(e.target.value) })}
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Label className="small fw-bold">Data Compra</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={formCadastro.eqp_datacompra}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_datacompra: e.target.value })}
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Label className="small fw-bold">CNPJ Nota</Form.Label>
                                <Form.Control
                                    value={formCadastro.eqp_cnpjnota}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_cnpjnota: e.target.value })}
                                />
                            </Col>
                        </Row>
                        <Row className="g-2 mb-2">
                            <Col md={4}>
                                <Form.Label className="small fw-bold">Nº Nota Fiscal</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={formCadastro.eqp_numnota}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_numnota: e.target.value })}
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Label className="small fw-bold">Série Nota</Form.Label>
                                <Form.Control
                                    value={formCadastro.eqp_serienota}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_serienota: e.target.value })}
                                />
                            </Col>
                            <Col md={4}>
                                <Form.Label className="small fw-bold">Chave NFe / ID</Form.Label>
                                <Form.Control
                                    value={formCadastro.eqp_idnfe}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_idnfe: e.target.value })}
                                />
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModalCadastro(false)}>Cancelar</Button>
                        <Button variant="danger" className="btn-arbor-primary" type="submit">Salvar Equipamento</Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Modal de Detalhes */}
            <Modal show={showModalDetalhes} onHide={() => setShowModalDetalhes(false)} size="lg" centered>
                <Modal.Header closeButton className="modal-header-arbor">
                    <Modal.Title className="h6 fw-bold text-white">
                        Dispositivo: {eqpSelecionado?.EQP_SERIE || eqpSelecionado?.eqp_serie}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                        <span className="fw-bold text-muted">Status Atual: {getBadgeStatus(eqpSelecionado?.EQP_STATUS || eqpSelecionado?.eqp_status)}</span>
                        <Button
                            variant={modoEdicao ? "outline-secondary" : "outline-danger"}
                            size="sm"
                            onClick={() => setModoEdicao(!modoEdicao)}
                        >
                            {modoEdicao ? "🔒 Modo Visualização" : "✏️ Modo Edição"}
                        </Button>
                    </div>

                    <Form onSubmit={handleSalvarEquipamento}>
                        <Row className="g-3">
                            <Col md={4}>
                                <Form.Label className="small fw-bold">Tipo</Form.Label>
                                <Form.Select
                                    disabled={!modoEdicao}
                                    value={formCadastro.eqp_tipo}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_tipo: e.target.value })}
                                >
                                    <option value="BALANÇA ATENDIMENTO">BALANÇA ATENDIMENTO</option>
                                    <option value="BALANÇA PDV">BALANÇA PDV</option>
                                    <option value="CELULAR">CELULAR</option>
                                    <option value="COLETOR">COLETOR</option>
                                    <option value="DESKTOP">DESKTOP</option>
                                    <option value="IMPRESSORA">IMPRESSORA</option>
                                    <option value="LEITOR">LEITOR</option>
                                    <option value="MONITOR">MONITOR</option>
                                    <option value="NOTEBOOK">NOTEBOOK</option>
                                    <option value="PINPAD">PINPAD</option>
                                    <option value="SCANER PDV">SCANER PDV</option>
                                    <option value="TELEVISÃO">TELEVISÃO</option>
                                </Form.Select>
                            </Col>
                            <Col md={4}>
                                <Form.Label className="small fw-bold">Nº de Série</Form.Label>
                                <Form.Control disabled readOnly value={formCadastro.eqp_serie} />
                            </Col>
                            <Col md={4}>
                                <Form.Label className="small fw-bold">Marca</Form.Label>
                                <Form.Control
                                    disabled={!modoEdicao}
                                    value={formCadastro.eqp_marca}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_marca: e.target.value })}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Modelo</Form.Label>
                                <Form.Control
                                    disabled={!modoEdicao}
                                    value={formCadastro.eqp_modelo}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_modelo: e.target.value })}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Usuário / Loja Atual</Form.Label>
                                <Form.Control
                                    disabled
                                    readOnly
                                    value={eqpSelecionado ? getDestinoFormatado(eqpSelecionado) : "Sem Vínculo"}
                                />
                            </Col>

                            {formCadastro.eqp_tipo === 'CELULAR' && formCadastro.eqp_celular && (
                                <Col md={12}>
                                    <Form.Label className="small fw-bold">Número da Linha / Celular Vinculado</Form.Label>
                                    <Form.Control
                                        disabled
                                        readOnly
                                        className="bg-light fw-bold text-danger"
                                        value={formCadastro.eqp_celular}
                                    />
                                </Col>
                            )}

                            <Col md={12}>
                                <Form.Label className="small fw-bold">Descrição / Configuração</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    disabled={!modoEdicao}
                                    value={formCadastro.eqp_descricao}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_descricao: e.target.value })}
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label className="small fw-bold">Valor (R$)</Form.Label>
                                <Form.Control
                                    type="text"
                                    disabled={!modoEdicao}
                                    value={formCadastro.eqp_valor}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_valor: aplicarMascaraMoeda(e.target.value) })}
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label className="small fw-bold">Data Compra</Form.Label>
                                <Form.Control
                                    type="date"
                                    disabled={!modoEdicao}
                                    value={formCadastro.eqp_datacompra}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_datacompra: e.target.value })}
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label className="small fw-bold">Nº Nota Fiscal</Form.Label>
                                <Form.Control
                                    type="number"
                                    disabled={!modoEdicao}
                                    value={formCadastro.eqp_numnota}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_numnota: e.target.value })}
                                />
                            </Col>
                            <Col md={3}>
                                <Form.Label className="small fw-bold">CNPJ Nota</Form.Label>
                                <Form.Control
                                    disabled={!modoEdicao}
                                    value={formCadastro.eqp_cnpjnota}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_cnpjnota: e.target.value })}
                                />
                            </Col>
                            <Col md={12} className="mt-2">
                                <Form.Label className="small fw-bold">Chave NFe / ID</Form.Label>
                                <Form.Control
                                    disabled={!modoEdicao}
                                    value={formCadastro.eqp_idnfe}
                                    onChange={(e) => setFormCadastro({ ...formCadastro, eqp_idnfe: e.target.value })}
                                />
                            </Col>
                        </Row>

                        {modoEdicao && (
                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <Button variant="secondary" onClick={() => setModoEdicao(false)}>Cancelar Edição</Button>
                                <Button variant="success" type="submit">Gravar Alterações</Button>
                            </div>
                        )}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalDetalhes(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Vinculação */}
            <Modal show={showModalVinculo} onHide={() => setShowModalVinculo(false)} centered>
                <Form onSubmit={handleVincularEquipamento}>
                    <Modal.Header closeButton className="bg-success text-white">
                        <Modal.Title className="h6 fw-bold">Vincular Equipamento</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Tipo de Vinculação</Form.Label>
                            <div>
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Colaborador (Usuário)"
                                    name="tipoVinculo"
                                    id="vinc-usuario"
                                    checked={tipoVinculo === "U"}
                                    onChange={() => setTipoVinculo("U")}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Loja / Empresa"
                                    name="tipoVinculo"
                                    id="vinc-loja"
                                    checked={tipoVinculo === "L"}
                                    onChange={() => setTipoVinculo("L")}
                                />
                            </div>
                        </Form.Group>

                        {tipoVinculo === "U" ? (
                            <>
                                <Form.Group className="mb-2">
                                    <Form.Label className="small fw-bold">Matrícula / Chapa</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            required
                                            value={chapaUsuario}
                                            onChange={(e) => setChapaUsuario(e.target.value)}
                                        />
                                        <Button variant="outline-secondary" onClick={handleBuscarUsuario}>Buscar</Button>
                                    </InputGroup>
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label className="small fw-bold">Nome do Colaborador</Form.Label>
                                    <Form.Control readOnly value={nomeUsuario} />
                                </Form.Group>
                            </>
                        ) : (
                            <Form.Group className="mb-2">
                                <Form.Label className="small fw-bold">Código da Loja / Empresa</Form.Label>
                                <Form.Control
                                    required
                                    placeholder="Ex: 1, 2, 3..."
                                    value={codLoja}
                                    onChange={(e) => setCodLoja(e.target.value)}
                                />
                            </Form.Group>
                        )}

                        {(eqpSelecionado?.EQP_TIPO === 'CELULAR' || eqpSelecionado?.eqp_tipo === 'CELULAR') && (
                            <Form.Group className="mb-2 mt-2">
                                <Form.Label className="small fw-bold">Número da Linha / Celular</Form.Label>
                                <Form.Control
                                    placeholder="(00) 00000-0000"
                                    value={celularUsuario}
                                    onChange={(e) => setCelularUsuario(e.target.value)}
                                />
                            </Form.Group>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModalVinculo(false)}>Cancelar</Button>
                        <Button
                            variant="success"
                            type="submit"
                            disabled={tipoVinculo === 'U' && !nomeUsuario}
                        >
                            Confirmar Vínculo
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* MOMENTO 1: Modal Abertura de Manutenção */}
            <Modal show={showModalAbrirManut} onHide={() => setShowModalAbrirManut(false)} size="lg" centered>
                <Form onSubmit={handleAbrirManutencao}>
                    <Modal.Header closeButton className="bg-warning text-dark">
                        <Modal.Title className="h6 fw-bold">
                            🛠️ Enviar para Manutenção ({eqpSelecionado?.EQP_SERIE || eqpSelecionado?.eqp_serie})
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="g-2 mb-2">
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Prestador / Fornecedor</Form.Label>
                                <Form.Control
                                    required
                                    placeholder="Ex: Dell, Zebra, Toledo..."
                                    value={formAbrirManut.prestador}
                                    onChange={(e) => setFormAbrirManut({ ...formAbrirManut, prestador: e.target.value })}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Empresa / Loja Origem</Form.Label>
                                <Form.Control
                                    type="number"
                                    placeholder="Ex: 1"
                                    value={formAbrirManut.cod_emp_origem}
                                    onChange={(e) => setFormAbrirManut({ ...formAbrirManut, cod_emp_origem: e.target.value })}
                                />
                            </Col>
                        </Row>

                        <Row className="g-2 mb-2">
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Nº Chamado Local</Form.Label>
                                <Form.Control
                                    placeholder="Ex: CHM-10293"
                                    value={formAbrirManut.numchamado_local}
                                    onChange={(e) => setFormAbrirManut({ ...formAbrirManut, numchamado_local: e.target.value })}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Nº Chamado Prestador</Form.Label>
                                <Form.Control
                                    placeholder="Ex: INC-99201"
                                    value={formAbrirManut.numchamado_prestador}
                                    onChange={(e) => setFormAbrirManut({ ...formAbrirManut, numchamado_prestador: e.target.value })}
                                />
                            </Col>
                        </Row>

                        <Form.Group className="mb-2">
                            <Form.Label className="small fw-bold">Defeito Relatado pelo Técnico</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                required
                                placeholder="Descreva o defeito relatado do equipamento pelo técnico..."
                                value={formAbrirManut.defeito_relatado}
                                onChange={(e) => setFormAbrirManut({ ...formAbrirManut, defeito_relatado: e.target.value })}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModalAbrirManut(false)}>Cancelar</Button>
                        <Button variant="warning" type="submit" className="fw-bold">REGISTRAR ENVIO</Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* MOMENTO 2: Modal Orçamento */}
            <Modal show={showModalOrcamento} onHide={() => setShowModalOrcamento(false)} size="lg" centered>
                <Form onSubmit={handleSalvarOrcamento}>
                    <Modal.Header closeButton className="bg-info text-white">
                        <Modal.Title className="h6 fw-bold">
                            📄 Orçamento da Prestadora ({eqpSelecionado?.EQP_SERIE || eqpSelecionado?.eqp_serie})
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="g-2 mb-2">
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Valor do Orçamento (R$)</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    value={formOrcamento.valor_orcamento}
                                    onChange={(e) => setFormOrcamento({ ...formOrcamento, valor_orcamento: aplicarMascaraMoeda(e.target.value) })}
                                />
                            </Col>
                            <Col md={6}>
                                <Form.Label className="small fw-bold">Status do Orçamento</Form.Label>
                                <Form.Select
                                    value={formOrcamento.acao_aprova}
                                    onChange={(e) => setFormOrcamento({ ...formOrcamento, acao_aprova: e.target.value })}
                                >
                                    <option value="Orçamento Enviado">Orçamento Enviado (Pendente)</option>
                                    <option value="Orçamento Autorizado">Orçamento Autorizado (Aprovado)</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        <Form.Group className="mb-2">
                            <Form.Label className="small fw-bold">Defeito Constatado pelo Prestador</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                placeholder="Defeito identificado pelo prestador de serviço..."
                                value={formOrcamento.defeito_constatado}
                                onChange={(e) => setFormOrcamento({ ...formOrcamento, defeito_constatado: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-2">
                            <Form.Label className="small fw-bold">Anexar Orçamento (PDF)</Form.Label>
                            <Form.Control
                                type="file"
                                accept=".pdf,image/*"
                                onChange={(e) => setFormOrcamento({ ...formOrcamento, arq_orcamento: e.target.files[0] })}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModalOrcamento(false)}>Cancelar</Button>
                        <Button variant="info" type="submit" className="text-white fw-bold">
                            GRAVAR ORÇAMENTO
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* MOMENTO 3: Modal Finalizar */}
            <Modal show={showModalFinalizarManut} onHide={() => setShowModalFinalizarManut(false)} centered>
                <Form onSubmit={handleFinalizarManutencao}>
                    <Modal.Header closeButton className="bg-success text-white">
                        <Modal.Title className="h6 fw-bold">
                            ✅ Registrar Retorno / Finalizar ({eqpSelecionado?.EQP_SERIE || eqpSelecionado?.eqp_serie})
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Valor Final do Serviço (R$)</Form.Label>
                            <Form.Control
                                type="text"
                                required
                                value={formFinalizarManut.valor_final}
                                onChange={(e) => setFormFinalizarManut({ ...formFinalizarManut, valor_final: aplicarMascaraMoeda(e.target.value) })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Serviço Realizado / Peças Trocadas</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                placeholder="Descrição do reparo..."
                                value={formFinalizarManut.servico_realizado}
                                onChange={(e) => setFormFinalizarManut({ ...formFinalizarManut, servico_realizado: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold">Anexar Nota Fiscal (Opcional se pendente)</Form.Label>
                            <Form.Control
                                type="file"
                                accept=".pdf,image/*"
                                onChange={(e) => setFormFinalizarManut({ ...formFinalizarManut, arq_notafiscal: e.target.files[0] })}
                            />
                            <Form.Text className="text-muted">
                                Se a NF não chegou, deixe em branco. Poderá ser anexada depois pelo histórico/logs.
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModalFinalizarManut(false)}>Cancelar</Button>
                        <Button variant="success" type="submit" className="fw-bold">
                            REGISTRAR RETORNO (SEM / COM NF)
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Modal de Logs */}
            <Modal show={showModalLogs} onHide={() => setShowModalLogs(false)} size="xl" centered>
                <Modal.Header closeButton className="modal-header-arbor">
                    <Modal.Title className="h6 fw-bold text-white">
                        📜 Histórico Completo de Vínculos e Manutenções ({eqpSelecionado?.EQP_SERIE || eqpSelecionado?.eqp_serie})
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <Table responsive hover className="mb-0 align-middle small">
                        <thead className="table-dark">
                            <tr>
                                <th>Data/Hora</th>
                                <th>Status Movimento</th>
                                <th>Usuário Ativo / Resp.</th>
                                <th>Detalhamento / Observações (DE-&gt;PARA)</th>
                                <th className="text-center">Visualizar Em Tela</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="text-center py-3 text-muted">Nenhum histórico encontrado.</td>
                                </tr>
                            ) : (
                                logs.map((l, i) => {
                                    const statusMov = String(l.EQPL_STATUS || l.eqpl_status || "").trim();
                                    const nomeUsuario = l.NOME_USUARIO || l.nome_usuario;
                                    const nomeLoja = l.NOME_LOJA || l.nome_loja;
                                    const codEmp = l.EQPL_COD_EMP || l.eqpl_cod_emp;
                                    const eqplUsuario = l.EQPL_USUARIO || l.eqpl_usuario;
                                    const usrLogadoNome = l.NOME_USUARIOLOGADO || l.nome_usuariologado;
                                    const usrLogadoMat = l.EQPL_USUARIOLOGADO || l.eqpl_usuariologado;

                                    const usuarioAtivo = nomeUsuario || (nomeLoja ? `Loja ${codEmp} - ${nomeLoja}` : (codEmp ? `Loja ${codEmp}` : null)) || eqplUsuario || "—";
                                    const usuarioResp = usrLogadoNome || usrLogadoMat || "—";

                                    const valHasOrcamento = l.EQPM_HAS_ORCAMENTO ?? l.eqpm_has_orcamento ?? 0;
                                    const valHasNota = l.EQPM_HAS_NOTA ?? l.eqpm_has_nota ?? 0;

                                    const isStatusOrcamento = statusMov.toLowerCase().includes('orçamento') || statusMov.toLowerCase().includes('manutenção');
                                    const isStatusFinalizado = ['finalizado', 'devolvido'].includes(statusMov.toLowerCase());

                                    const showBtnOrcamento = Number(valHasOrcamento) > 0 && isStatusOrcamento;
                                    const showBtnNota = Number(valHasNota) > 0 && isStatusFinalizado;

                                    const eqpmId = l.EQPM_ID || l.eqpm_id;

                                    return (
                                        <tr key={i}>
                                            <td style={{ whiteSpace: 'nowrap' }}>{l.EQPL_DATAHORA || l.eqpl_datahora}</td>
                                            <td>
                                                <Badge bg={statusMov === 'Edição de Equipamento' ? 'dark' : 'danger'}>
                                                    {statusMov}
                                                </Badge>
                                            </td>
                                            <td>
                                                <div><strong className="text-dark">{usuarioAtivo}</strong></div>
                                                <div className="text-muted" style={{ fontSize: '0.75rem' }}>👤 Resp: {usuarioResp}</div>
                                            </td>
                                            <td>
                                                <div style={{ maxWidth: '400px', wordBreak: 'break-word' }}>{l.EQPL_OBSERVACAO || l.eqpl_observacao}</div>
                                            </td>
                                            <td className="text-center">
                                                <div className="d-flex justify-content-center gap-1 align-items-center">
                                                    {showBtnOrcamento && (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-primary"
                                                            style={{ fontSize: '0.7rem' }}
                                                            onClick={() => handleVisualizarAnexoEmTela(eqpmId, 'orcamento', '📄 Orçamento de Manutenção')}
                                                        >
                                                            👁️ Ver Orçamento
                                                        </Button>
                                                    )}
                                                    {showBtnNota ? (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-success"
                                                            style={{ fontSize: '0.7rem' }}
                                                            onClick={() => handleVisualizarAnexoEmTela(eqpmId, 'notafiscal', '🧾 Nota Fiscal / Comprovante')}
                                                        >
                                                            👁️ Ver Nota Fiscal
                                                        </Button>
                                                    ) : (
                                                        statusMov.toLowerCase() === 'finalizado' && eqpmId ? (
                                                            <label className="btn btn-sm btn-outline-warning py-0 px-2 mb-0" style={{ fontSize: '0.7rem', cursor: 'pointer' }}>
                                                                📎 Anexar NF
                                                                <input
                                                                    type="file"
                                                                    accept=".pdf,image/*"
                                                                    style={{ display: 'none' }}
                                                                    onChange={(e) => {
                                                                        if (e.target.files[0]) {
                                                                            handleEnviarNfPendente(eqpmId, e.target.files[0]);
                                                                        }
                                                                    }}
                                                                />
                                                            </label>
                                                        ) : (
                                                            <span className="text-muted">—</span>
                                                        )
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalLogs(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal de Visualização de Anexo */}
            <Modal show={showModalAnexo} onHide={handleFecharModalAnexo} size="lg" centered style={{ zIndex: 1060 }}>
                <Modal.Header closeButton className="modal-header-arbor">
                    <Modal.Title className="h6 fw-bold text-white">{tituloAnexoView}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0 d-flex justify-content-center align-items-center bg-secondary" style={{ height: '75vh' }}>
                    {urlAnexoView ? (
                        isImagemView ? (
                            <img
                                src={urlAnexoView}
                                alt="Anexo"
                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                            />
                        ) : (
                            <iframe
                                src={urlAnexoView}
                                title="Visualizador de Anexo"
                                width="100%"
                                height="100%"
                                style={{ border: 'none' }}
                            />
                        )
                    ) : (
                        <div className="text-center p-5 text-white">Não foi possível carregar o arquivo.</div>
                    )}
                </Modal.Body>
            </Modal>

            {/* Spinner Global */}
            <Modal show={loading} backdrop="static" keyboard={false} centered size="sm" contentClassName="bg-transparent border-0">
                <Modal.Body className="text-center">
                    <Spinner animation="border" style={{ color: '#8b0000', width: '3rem', height: '3rem' }} />
                    <div className="text-light mt-2 fw-bold">Carregando...</div>
                </Modal.Body>
            </Modal>

            <Footer />
        </div>
    );
}

export default ControleEquipamentos;